import ProbabilityTree, {
  type Props,
} from 'ms-components/math/ProbabilityTree';

export default function ProbabilityTreeReadOnly(props: Props) {
  return <ProbabilityTree {...props} readOnly />;
}
